class CartDrawerRecommendations extends HTMLElement {
  constructor() {
    super();
    this.sectionUrl = this.dataset.sectionUrl;
    this.lastProductId = this.dataset.productId || null;
    this.onCartUpdate = this.onCartUpdate.bind(this);
  }

  connectedCallback() {
    console.log("[cart-drawer-recommendations] connected", {
      productId: this.lastProductId,
      sectionUrl: this.sectionUrl,
    });

    if (this.lastProductId) {
      this.fetchRecommendations(this.lastProductId);
    } else {
      console.log("[cart-drawer-recommendations] no product id on init, waiting for cart update");
    }

    if (window.FoxThemeEvents && typeof PUB_SUB_EVENTS !== "undefined") {
      this.cartUpdateUnsubscriber = window.FoxThemeEvents.subscribe(
        PUB_SUB_EVENTS.cartUpdate,
        this.onCartUpdate
      );
    } else {
      console.warn("[cart-drawer-recommendations] FoxThemeEvents/PUB_SUB_EVENTS not available — cart updates won't refresh recommendations");
    }
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onCartUpdate(state) {
    if (!state) return;

    let newProductId = "";
    let currentItemCount = null;

    if (Array.isArray(state.items) && state.items.length > 0) {
      const lastItem = state.items[state.items.length - 1];
      newProductId = String(lastItem.product_id || lastItem.id || "");
      currentItemCount = state.items.length;
    } else if (Array.isArray(state.items) && state.items.length === 0) {
      this.replaceChildren();
      this.lastProductId = null;
      this.lastItemCount = 0;
      return;
    } else if (state.product_id) {
      newProductId = String(state.product_id);
    } else {
      return;
    }

    if (!newProductId) return;

    const productChanged = newProductId !== String(this.lastProductId);
    const itemCountChanged = currentItemCount !== null && currentItemCount !== this.lastItemCount;

    if (!productChanged && !itemCountChanged) return;

    this.lastProductId = newProductId;
    if (currentItemCount !== null) this.lastItemCount = currentItemCount;
    this.fetchRecommendations(newProductId);
  }

  fetchRecommendations(productId) {
    if (!this.sectionUrl || !productId) {
      console.warn("[cart-drawer-recommendations] missing sectionUrl or productId", { sectionUrl: this.sectionUrl, productId });
      return;
    }

    const separator = this.sectionUrl.includes("?") ? "&" : "?";
    const url = `${this.sectionUrl}${separator}product_id=${encodeURIComponent(productId)}`;
    console.log("[cart-drawer-recommendations] fetching", url);

    fetch(url)
      .then((response) => {
        console.log("[cart-drawer-recommendations] response status", response.status);
        return response.text();
      })
      .then((text) => {
        const parsed = new DOMParser().parseFromString(text, "text/html");
        const section = parsed.querySelector(
          "#shopify-section-cart-drawer-recommendations"
        );
        const itemCount = section ? section.querySelectorAll(".f-cart-empty__bestseller").length : 0;
        const source = section ? section.querySelector("[data-source]")?.dataset.source : "none";
        console.log("[cart-drawer-recommendations] parsed", {
          sectionFound: !!section,
          itemCount,
          source,
          rawLength: text.length,
        });
        if (section && itemCount > 0) {
          this.replaceChildren(...section.childNodes);
        } else {
          this.replaceChildren();
        }
      })
      .catch((err) =>
        console.error("[cart-drawer-recommendations] fetch error:", err)
      );
  }
}

customElements.define("cart-drawer-recommendations", CartDrawerRecommendations);
